exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.arrbox[data-v-c71ff98a] {\n  background-color: white;\n  font-size: 12px;\n  border-radius: 6px;\n  margin-bottom: 0px;\n  text-align: left;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 460px;\n}\n", ""]);

// exports
